import React from "react";

import { CSSGrid } from "@components/Layout/CssGrid";

import { Title } from "./Title";
import { USPs } from "./USPs";
import { Selector } from "./Selector";

export const titleAreas = CSSGrid.areas({
  Title,
  USPs,
});

titleAreas.all(({ Title, USPs }, { repeat }) => [
  repeat(Title, 12),
  repeat(USPs, 7),
]);

titleAreas.smallTablet(({ Title, USPs }, { repeat }) => [
  repeat(Title, 8),
  repeat(USPs, 8),
]);

titleAreas.tablet(({ Title, USPs }, { repeat }) => [
  repeat(Title, 10),
  repeat(USPs, 10),
]);

titleAreas.smallDesktop(({ Title, USPs }, { repeat }) => [
  repeat(Title, 9),
  repeat(USPs, 9),
]);

export const selectorAreas = CSSGrid.areas({
  Selector,
});

selectorAreas.all(({ Selector }, { repeat }) => [repeat(Selector, 12)]);

selectorAreas.smallTablet(({ Selector }, { repeat }) => [repeat(Selector, 10)]);

selectorAreas.smallDesktop(({ Selector }, { repeat }) => [repeat(Selector, 8)]);
